import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import { RiInformationFill } from 'react-icons/ri';
import { changePassword } from '../SignUp/Validation';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
const inputError = {};
export const ChangePassword = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [instruction, setInstruction] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(inputError);
  const [inputs, setInputs] = useState({
    password: '',
    confirmPassword: '',
    otp: '',
  });
  const navigate = useNavigate();
  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userEmail = JSON.parse(sessionStorage.getItem('resetUserEmail'));
    setError(changePassword(inputs));
    if (Object.keys(error).length) return;

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/recover-password/two`,
        {
          email: userEmail,
          password: inputs.password,
          otp: inputs.otp,
        }
      );
      toast.success(response.data.message);
      sessionStorage.removeItem('resetUserEmail');
      navigate('/signin');
    } catch (error) {
      console.log(error.response.data.message);
      setError(error.response.data.message);
    } finally {
      setIsLoading(isLoading);
    }
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
    setConfirmPasswordShown(!passwordShown);
  };
  const inputReference = useRef(null);
  useEffect(() => {
    if (inputReference.current !== null) {
      inputReference.current.focus();
    }
  }, []);

  return (
    <div className='h-screen relative max-w-lg mx-auto'>
      <div className='w-full  pb-16 bg-p-wh flex items-center flex-col gap-8 rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-16 px-6'>
        <div className='font-pin flex items-center flex-col'>
          <h1 className='text-2xl text center font-semibold text-p-pin pb-2'>
            Change Password
          </h1>
          <p>Create a new password to login</p>
        </div>

        <form
          className='flex items-center flex-col gap-4 w-full box-border'
          onSubmit={handleSubmit}
        >
          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              OTP<sup className='text-red-500'>*</sup>
            </label>
            <input
              type='number'
              className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
              placeholder='Enter OTP'
              name='otp'
              value={inputs.otp}
              onChange={handleChange}
            />
            <small className='text-red-500'>{inputError.otp}</small>
          </div>
          <div className='flex flex-col gap-2 w-full relative'>
            <label className='text-p-bk text-base font-pin'>
              Password<sup className='text-red-500'>*</sup>
            </label>
            <input
              type={passwordShown ? 'text' : 'password'}
              className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
              name='password'
              placeholder='Create new password'
              value={inputs.password}
              onChange={handleChange}
              ref={inputs.password ? null : inputReference}
              onFocus={() => {
                setInstruction(!instruction);
              }}
              onBlur={() => {
                if (instruction) {
                  setInstruction(!instruction);
                }
              }}
            />
            {passwordShown ? (
              <HiEye
                className='absolute bottom-3 right-4'
                onClick={togglePassword}
              />
            ) : (
              <HiEyeOff
                className='absolute bottom-3 right-4 text-s-bk'
                onClick={togglePassword}
              />
            )}
          </div>
          {instruction ? (
            <div className='flex flex-row gap-2 w-full text-s-bk bg-b-mct px-4 py-4 rounded-lg'>
              <span className='text-2xl'>
                <RiInformationFill />
              </span>
              <p className='text-xs'>
                Minimum eight characters, at least one letter, one number and
                one special character
              </p>
            </div>
          ) : null}

          <div className='flex flex-col gap-2 w-full relative'>
            <label className='text-p-bk text-base font-pin'>
              Confirm password<sup className='text-red-500'>*</sup>
            </label>
            <input
              type={confirmPasswordShown ? 'text' : 'password'}
              className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
              name='confirmPassword'
              placeholder='Confirm password'
              value={inputs.confirmPassword}
              onChange={handleChange}
            />
            {passwordShown ? (
              <HiEye
                className='absolute bottom-3 right-4'
                onClick={togglePassword}
              />
            ) : (
              <HiEyeOff
                className='absolute bottom-3 right-4 text-s-bk'
                onClick={togglePassword}
              />
            )}
          </div>
          <small>{error.confirmPassword}</small>
          <button
            className='text-p-wh justify-center  hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-2.5 w-full my-4 font-semibold disabled:bg-b-mct bg-b-mc rounded-lg relative'
            disabled={isLoading}
          >
            Change password
            {isLoading ? (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
                className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
              />
            ) : null}
          </button>
        </form>
      </div>
    </div>
  );
};
